module.exports = __webpack_public_path__ + "img/avatar0.2c74562b.png";